import api from '../../lib/api';

export const getProgress = pathway =>
  function get(dispatch) {
    api
      .sendGet(`/public-dashboard?pathway=${pathway}`, (error, response) => {
        if (error) return console.error(error);

        let fill = 'rgba(255,150,132,0.2)';
        let stroke = 'rgba(255,99,131,0.8)';
        let highlightFill = 'rgba(255,150,132,0.2)';
        let highlightStroke = 'rgba(255,99,131,0.8)';

        switch (pathway) {
          case 'weight':
          case 'activity':
          case 'smoking':
          case 'alcohol':
            fill = 'rgba(255,150,132,0.2)';
            stroke = 'rgba(255,99,131,0.8)';
            highlightFill = 'rgba(255,150,132,0.2)';
            highlightStroke = 'rgba(255,99,131,0.8)';
            break;
          default:
            break;
        }
        const result = {
          data: {
            labels: response.data.labels,
            dataset: {
              data: response.data.data,
              fillColor: fill,
              strokeColor: stroke,
              highlightFill,
              highlightStroke,
            },
            average: response.data.average,
            improvement: response.data.improvement,
            message: response.data.message,
            catchup: response.data.catchup,
            catchupType: response.data.catchupType,
            progress: response.data.progress,
            benchmark: response.data.benchmark,
            first: response.data.first,
            last: response.data.last,
          },
        };

        return dispatch(getProgressSuccess(result.data));
      });
  };

export const getProgressSuccess = data => ({
  type: 'GET_PROGRESS_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/progress.js